import DeviceList from '../features/DeviceList/index.web';

const DeviceListWidget = ({
  setShowCurrentDevice,
  setShowDeviceSettings,
  selectedGroup,
  setSelectedGroup,
  setStartTime,
  setEndTime,
}) => {
  const noop = () => {};
  return (
    <div className="h-100 w-100">
      <DeviceList
        setShowCurrentDevice={setShowCurrentDevice}
        setShowDeviceSettings={setShowDeviceSettings}
        selectedGroup={selectedGroup}
        setSelectedGroup={setSelectedGroup}
        setStartTime={setStartTime || noop}
        setEndTime={setEndTime || noop}
        widget
      />
    </div>
  );
};

export default DeviceListWidget;
